
import { defineComponent } from "vue";
import ImageCard from "@/components/bono/ImageCard.vue";
import BonoBannerStripe from "@/components/bono/BonoBannerStripe.vue";

export default defineComponent({
  components: {
    ImageCard,
    BonoBannerStripe,
  },
  props: {
    withoutIcon: { type: Boolean },
  },
  setup() {
    return {
      baseURL: process.env.BASE_URL,
    };
  },
});
